import { Settings2 } from "lucide-react";

export const EmptyPreviewSidebar = () => (
  <div className="flex h-full w-full flex-col items-center justify-center rounded-md border border-dashed border-gray-300 bg-gray-50 p-8 text-center shadow-sm transition-all hover:bg-gray-100/50">
    <Settings2 className="mb-2 h-10 w-10 text-gray-400" />
    <p className="mb-1 font-medium text-gray-700">No parameter selected</p>
    <p className="text-xs text-gray-500">
      Choose a parameter type from the selector to get started
    </p>
  </div>
);
